import DianZan from './lib/zan';

export default DianZan;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.dianzan.pc/app/index.js